// extracted by mini-css-extract-plugin
module.exports = {"title":"ConfigsReview_title__3f14v","botConfigList":"ConfigsReview_botConfigList__3KOB8","configTitle":"ConfigsReview_configTitle__1h8jI","tooltip":"ConfigsReview_tooltip__1QrrM"};